export default __webpack_public_path__ + "static/media/female.799edeb0.jpg";